/* ===========================================================================
   product-card.js
   ---------------------------------------------------------------------------
   Behaviour for every <product-card>.
   - Runs once per card (data-pc-ready flag).
   - Can be called again for cards injected later (infinite scroll).
   =========================================================================== */

(function () {
  /**
   * Initialise a NodeList/array of product-card elements.
   * If no argument is passed we auto-select every card that has not been
   * initialised yet.
   */
  function initProductCards(
    cards = document.querySelectorAll('.product-card:not([data-pc-ready])'),
    options = {}
  ) {
    if (!cards.length) return;

    /* ---------- 1. Card-level setup ----------------------------------- */
    cards.forEach(function (card) {
      card.dataset.pcReady = '1';                 // guard
      const slider   = card.querySelector('.product-card__slider');
      if (!slider) return;                        // safety guard

      /* 1-a: flags ------------------------------------------------------ */
      let   isLookbook = card.dataset.lookbook === 'true';
      const isHover3   = card.dataset.hover3   === 'true';
      const isHover2 = card.dataset.hover2 === 'true';
      const isWoman = card.classList.contains('is_woman');
      if (window.location.pathname === '/') isLookbook = false;
      
      /* NUEVO: Detectar si es un producto Bicycle y si estamos en su página */
      const handle = card.getAttribute('handle') || '';
      const isBicycleProduct = handle.includes('bicycle') || handle.includes('playing-cards');
      const isOnBicyclePage = window.location.pathname.includes('/collections/cold-culture-x-bicycle');
      const shouldDisableSwipe = isBicycleProduct && !isOnBicyclePage;

      /* 1-b: DOM refs & state ------------------------------------------- */
      const slides      = slider.querySelectorAll('.product-card__slide');
      const prevBtn     = card.querySelector('.product-card__slider-prev');
      const nextBtn     = card.querySelector('.product-card__slider-next');
      const dotsCont    = card.querySelector('.product-card__slider-dots');
      const dots        = dotsCont ? dotsCont.querySelectorAll('.product-card__slider-dot') : null;

      let currentIndex  = 0;
      const total       = slides.length;
      const maxDots     = 3;
      const dotsShown   = Math.min(maxDots, total);
      let hovered       = false;

      /* 1-c: helpers ---------------------------------------------------- */
      /* MODIFICADO: se precarga con la propia <img> para que el navegador
         elija el tamaño del srcset. Antes se hacía new Image().src = img.src,
         que baja el src de reserva (1000 px en las PLP, 4000 px en la home). */
      const preload = i => {
        i = (i + total) % total;
        const img = slides[i]?.querySelector('img');
        if (img && !img.complete) img.loading = 'eager';
      };
      /* MODIFICADO: show() ya no precarga; solo se precarga tras un gesto
         del usuario (antes cada tarjeta bajaba su 2ª foto al cargar). */
      const show = idx => {
        idx = (idx + total) % total;
        currentIndex = idx;
        slides.forEach((s, i) => (s.style.display = i === idx ? 'block' : 'none'));
        if (dots) dots.forEach((d, i) => d.classList.toggle('is-active', i === (idx % dotsShown)));
      };
      const next = () => { show(currentIndex + 1); preload(currentIndex + 1); };
      const prev = () => { show(currentIndex - 1); preload(currentIndex - 1); };

      /* 1-c-bis: hydrate deferred slides (divs rendered without <img>).
         Runs once per card, on first interaction. Registered BEFORE the
         1-d navigation handlers so imgs exist before next()/prev() run. */
      const hydrateLazySlides = () => {
        if (card.dataset.pcHydrated === '1') return;
        card.dataset.pcHydrated = '1';
        const lazySlides = slider.querySelectorAll('[data-lazy-slide]');
        if (!lazySlides.length) return;
        const siblingImg = slider.querySelector('.product-card__slide img');
        const sizesAttr = siblingImg ? siblingImg.getAttribute('sizes') : null;
        lazySlides.forEach(function (slide) {
          const img = document.createElement('img');
          img.className = 'product-card__image';
          img.setAttribute('loading', 'lazy');
          img.setAttribute('decoding', 'async');
          if (sizesAttr) img.setAttribute('sizes', sizesAttr);
          if (slide.dataset.srcset) img.setAttribute('srcset', slide.dataset.srcset);
          if (slide.dataset.src) img.src = slide.dataset.src;
          img.alt = slide.dataset.alt || '';
          slide.appendChild(img);
          slide.removeAttribute('data-lazy-slide');
        });
      };
      card.addEventListener('pointerenter', hydrateLazySlides, { once: true });
      card.addEventListener('touchstart', hydrateLazySlides, { once: true, passive: true });
      prevBtn?.addEventListener('click', hydrateLazySlides);
      nextBtn?.addEventListener('click', hydrateLazySlides);

      /* NUEVO: al primer gesto sobre la tarjeta se calienta la siguiente foto */
      const warmUp = () => preload(currentIndex + 1);
      card.addEventListener('pointerenter', warmUp, { once: true });
      card.addEventListener('touchstart', warmUp, { once: true, passive: true });

      /* 1-d: UI events -------------------------------------------------- */
      nextBtn?.addEventListener('click', e => { e.preventDefault(); next(); });
      prevBtn?.addEventListener('click', e => { e.preventDefault(); prev(); });

      /* swipe (mobile) - MODIFICADO PARA BICYCLE */
      if (!shouldDisableSwipe) {
        // Solo añadir swipe si NO es un producto Bicycle fuera de su página
        let sx = null;
        // MODIFICADO: passive, para que el navegador no espere al JS antes de hacer scroll
        slider.addEventListener('touchstart',  e => { sx = e.changedTouches[0].screenX; }, { passive: true });
        slider.addEventListener('touchend',    e => {
          const dx = e.changedTouches[0].screenX - sx;
          if (dx >  50) prev();
          if (dx < -50) next();
        }, { passive: true });
      } else {
        // Para productos Bicycle fuera de su página, prevenir cualquier interacción de swipe
        slider.addEventListener('touchstart', e => { e.stopPropagation(); }, { capture: true, passive: true });
        slider.addEventListener('touchend', e => { e.stopPropagation(); }, { capture: true, passive: true });
        slider.addEventListener('touchmove', e => { e.stopPropagation(); }, { capture: true, passive: true });
      }

      /* hover (desktop) - MANTENER FUNCIONANDO PARA TODOS */
      const mediaWrap = card.querySelector('.product-card__media-wrapper');
      const desktop   = cb => { if (window.innerWidth > 768) cb(); };

      // Hover funciona normal para TODOS los productos incluyendo Bicycle
      mediaWrap?.addEventListener('mouseenter', () => desktop(() => {
        if (isLookbook) {
          if (currentIndex === 2 && total) { show(0); hovered = true; }
        } else if (mediaWrap.closest(".is_woman")) {
          show(0); hovered = true;
        } else if (isHover2) {
          if (currentIndex === 0 && total > 1) { show(1); hovered = true; }
        } else if (isHover3) {
          if (currentIndex === 0) { show(total > 2 ? 2 : 1); hovered = true; }
        } else if (currentIndex === 0 && total > 1) {
          show(1); hovered = true;
        }
      }));

      mediaWrap?.addEventListener('mouseleave', () => desktop(() => {
        if (!hovered) return;
        if (isLookbook)          show(total > 2 ? 2 : 0);
        if (mediaWrap.closest(".is_woman")) {
          const imageWoman = card.querySelector('.product-image--women');
          let inx = parseInt(imageWoman.getAttribute('index')) || 0;
          show(inx);
          currentIndex  = 0;
        }
        else                     show(0);
        hovered = false;
      }));

      /* NUEVO: precarga de la foto de hover, lanzada desde el bloque 2 solo
         cuando la tarjeta entra en pantalla (misma lógica que mouseenter) */
      card.addEventListener('pc:warm-hover', () => {
        if (total < 2) return;
        if (isLookbook || mediaWrap?.closest('.is_woman')) preload(0);
        else if (isHover3) preload(total > 2 ? 2 : 1);
        else preload(1);
      }, { once: true });

      /* 1-e: initial frame --------------------------------------------- */
      (function firstFrame() {
        if (shouldDisableSwipe) {
          show(0);
        } else if (!isWoman) {
          if (isLookbook) {
            show(total > 2 ? 2 : total > 1 ? 1 : 0);
          } else {
            const toolbar   = document.querySelector('.collection-toolbar');
            const handle    = toolbar?.getAttribute('data-collection-handle') || 'default';
            const key       = 'isProductView_' + handle;
            const gridView  = !(localStorage.getItem(key) === 'false');
            if (gridView)                show(0);
            else if (total > 2)          show(2);
            else if (total > 1)          show(1);
          }
        }
        slider.style.visibility = 'visible';
      })();
    });

    /* ---------- 2. Batch-level niceties ------------------------------- */

    /* fade-in cascade */
    if (!options.skipFade) (function fadeIn(list) {
      list = Array.from(list);
      let i = 0;
      function step() {
        if (i >= list.length) return;
        const c   = list[i++];
        c.style.opacity    = '0';
        c.style.transition = 'opacity 0.3s ease-out';
        const img = c.querySelector('.product-card__slide img');
        const go  = () => { c.style.opacity = '1'; setTimeout(step, 100); };
        if (!img || img.complete) go(); else img.addEventListener('load', go, { once: true });
      }
      step();
    })(cards);

    /* eager-preload 3rd image of hover3 cards (desktop) */
    if (window.innerWidth > 768) {
      cards.forEach(card => {
        if (card.dataset.hover2 === 'true') {
          const thirdImg = card.querySelectorAll('.product-card__slide img')[2];
          if (thirdImg && !thirdImg.complete) new Image().src = thirdImg.src;
        }
        
        if (card.dataset.hover3 === 'true') {
          const thirdImg = card.querySelectorAll('.product-card__slide img')[3];
          if (thirdImg && !thirdImg.complete) new Image().src = thirdImg.src;
        }
      });
    }
  }

  /* ---------------------------------------------------------------------
     Color swatches: click selects the color. No hover swap.
     Desktop "+" reveals up to 10 circles. Mobile "+" opens the PDP
     of the color selected on the card.
  --------------------------------------------------------------------- */
  const colorSwatchMobile = window.matchMedia('(max-width: 999px)');

  function normalizeText(value) {
    return (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  const colorEndings = {
    'dark grey': ['dark grey', 'heavy grey', 'washed grey'],
    'light grey': ['light grey', 'grey'],
    grey: ['grey'],
    green: ['jungle green', 'militar green', 'green'],
    blue: ['blue', 'midnight blue', 'new blue'],
    red: ['wine red', 'vibrant red', 'red'],
    'vibrant red': ['vibrant red'],
    black: ['black'],
    yellow: ['yellow', 'gold'],
    pink: ['pink'],
    burgundy: ['burgundy'],
    brown: ['brown'],
    'ash grey': ['ash grey'],
    'heather grey': ['heather grey'],
    navy: ['navy'],
    white: ['white'],
    beige: ['beige'],
    camo: ['camo'],
    orange: ['orange'],
    purple: ['purple'],
    gold: ['gold', 'yellow']
  };

  function endingsFor(color) {
    const extras = colorEndings[color] || [];
    return [color].concat(extras.filter(function (ending) { return ending !== color; }))
      .sort(function (a, b) { return b.length - a.length; });
  }

  function stripColor(title, color) {
    const name = normalizeText(title);
    const endings = endingsFor(color);
    for (let i = 0; i < endings.length; i++) {
      const ending = endings[i];
      if (name === ending || name.endsWith(' ' + ending)) {
        return name.slice(0, name.length - ending.length).trim();
      }
    }
    return '';
  }

  function productStems(title, selectedColor) {
    const stripped = stripColor(title, selectedColor);
    if (stripped) return [stripped];
    const words = normalizeText(title).split(' ').filter(Boolean);
    const stems = [];
    while (words.length >= 2) {
      stems.push(words.join(' '));
      if (words.length === 2) break;
      words.pop();
    }
    return stems;
  }

  function scoreTitle(productTitle, stem, color) {
    const title = normalizeText(productTitle);
    if (title !== stem && !title.startsWith(stem + ' ')) return -1;
    let best = -1;
    endingsFor(color).forEach(function (ending) {
      if (title !== ending && !title.endsWith(' ' + ending)) return;
      const middle = title.slice(stem.length, title.length - ending.length).trim();
      const extraWords = middle ? middle.split(' ').length : 0;
      if (extraWords > 1) return;
      const score = 100 - extraWords * 20 + (ending === color ? 30 : 0);
      if (score > best) best = score;
    });
    return best;
  }

  async function suggestProducts(query) {
    const endpoint = new URL('/search/suggest.json', window.location.origin);
    endpoint.searchParams.set('q', query);
    endpoint.searchParams.set('resources[type]', 'product');
    endpoint.searchParams.set('resources[limit]', '10');
    const response = await fetch(endpoint.toString());
    if (!response.ok) return [];
    const data = await response.json();
    return data?.resources?.results?.products || [];
  }

  function colorSlug(color) {
    return normalizeText(color).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function productHandle(path) {
    const parts = String(path || '').split('/').filter(Boolean);
    const index = parts.indexOf('products');
    return (index >= 0 ? parts[index + 1] : parts[parts.length - 1]) || '';
  }

  async function probeProductHandle(handle) {
    if (!handle) return '';
    const response = await fetch('/products/' + handle + '.js');
    if (!response.ok) return '';
    return '/products/' + handle;
  }

  async function resolveSwatchUrl(card, swatch) {
    const currentPath = new URL(
      card.querySelector('a.product-title')?.getAttribute('href') || window.location.href,
      window.location.origin
    ).pathname;
    if (swatch.dataset.url) {
      const nextPath = new URL(swatch.dataset.url, window.location.origin).pathname;
      if (nextPath && productHandle(nextPath) !== productHandle(currentPath)) return nextPath;
    }
    const title = card.querySelector('a.product-title')?.textContent || '';
    const group = swatch.closest('.color-swatches-new');
    const selectedColor = normalizeText(group?.querySelector('.is-selected')?.getAttribute('aria-label'));
    const nextColor = normalizeText(swatch.getAttribute('aria-label'));
    const currentHandle = currentPath.split('/').filter(Boolean).pop() || '';
    const selectedSlug = colorSlug(selectedColor);
    const nextSlug = colorSlug(nextColor);
    if (selectedSlug && nextSlug && currentHandle.endsWith('-' + selectedSlug)) {
      const stem = currentHandle.slice(0, -(selectedSlug.length + 1));
      const candidates = [stem + '-' + nextSlug];
      if (stem.indexOf('distress-') === 0) candidates.push('distressed-' + stem.slice('distress-'.length) + '-' + nextSlug);
      if (stem.indexOf('distressed-') === 0) candidates.push('distress-' + stem.slice('distressed-'.length) + '-' + nextSlug);
      for (let i = 0; i < candidates.length; i++) {
        const found = await probeProductHandle(candidates[i]);
        if (found) return found;
      }
    }
    if (!stripColor(title, selectedColor || nextColor)) {
      const familyUrl = await resolveFamilyUrl(currentPath, title, nextColor, group);
      if (familyUrl) return familyUrl;
    }
    const stems = productStems(title, selectedColor || nextColor);
    const endings = [nextColor].concat(endingsFor(nextColor).filter(function (ending) {
      return ending !== nextColor;
    }));
    for (let i = 0; i < stems.length; i++) {
      for (let j = 0; j < endings.length; j++) {
        const products = await suggestProducts(stems[i] + ' ' + endings[j]);
        let bestPath = '';
        let bestScore = -1;
        products.forEach(function (product) {
          const path = new URL(product.url, window.location.origin).pathname;
          if (productHandle(path) === productHandle(currentPath)) return;
          const score = scoreTitle(product.title, stems[i], nextColor);
          if (score > bestScore) {
            bestScore = score;
            bestPath = path;
          }
        });
        if (bestPath) return bestPath;
      }
    }
    return resolveFamilyUrl(currentPath, title, nextColor, group);
  }

  function sharesColorWord(color, words) {
    return color.split(' ').filter(function (word) { return word.length > 2; }).some(function (word) {
      return words.indexOf(word) !== -1;
    });
  }

  async function resolveFamilyUrl(currentPath, title, nextColor, group) {
    const words = normalizeText(title).split(' ').filter(Boolean);
    const colorWords = nextColor.split(' ').filter(function (word) { return word.length > 2; });
    if (words.length < 3 || !colorWords.length) return '';
    const otherLabels = group ? Array.from(group.querySelectorAll('.color-swatch-new')).map(function (swatch) {
      return normalizeText(swatch.getAttribute('aria-label'));
    }).filter(function (label) { return label && label !== nextColor; }) : [];
    for (let len = words.length - 1; len >= 3; len--) {
      const stem = words.slice(0, len).join(' ');
      const products = await suggestProducts(stem);
      const family = products.filter(function (product) {
        const name = normalizeText(product.title);
        return name === stem || name.startsWith(stem + ' ');
      });
      if (family.length < 2) continue;
      const currentHandle = productHandle(currentPath);
      const currentSuffix = family.reduce(function (suffix, product) {
        const path = new URL(product.url, window.location.origin).pathname;
        if (productHandle(path) !== currentHandle) return suffix;
        return normalizeText(product.title).slice(stem.length).trim().split(' ').filter(Boolean);
      }, []);
      const otherPaths = [];
      let bestPath = '';
      let bestScore = 0;
      let tied = false;
      family.forEach(function (product) {
        const path = new URL(product.url, window.location.origin).pathname;
        if (productHandle(path) === currentHandle) return;
        if (otherPaths.indexOf(path) === -1) otherPaths.push(path);
        const suffixWords = normalizeText(product.title).slice(stem.length).trim().split(' ').filter(Boolean);
        let score = 0;
        colorWords.forEach(function (word) {
          if (suffixWords.indexOf(word) !== -1) score += 2;
        });
        if (score > bestScore) {
          bestScore = score;
          bestPath = path;
          tied = false;
        } else if (score === bestScore && score > 0 && path !== bestPath) {
          tied = true;
        }
      });
      if (bestScore > 0 && !tied && bestPath) return bestPath;
      const clickedIsCurrent = sharesColorWord(nextColor, currentSuffix);
      const anotherSwatchIsCurrent = otherLabels.some(function (label) {
        return sharesColorWord(label, currentSuffix);
      });
      if (!clickedIsCurrent && anotherSwatchIsCurrent && otherPaths.length === 1) return otherPaths[0];
      break;
    }
    return '';
  }

  function keepSwatchOrder(previousCard, nextCard, productUrl) {
    const previous = previousCard.querySelector('.color-swatches-new');
    const nextGroup = nextCard.querySelector('.color-swatches-new');
    if (!previous || !nextGroup) return;
    const order = [];
    const prevUrls = new Map();
    previous.querySelectorAll('.color-swatch-new').forEach(function (swatch) {
      const key = normalizeText(swatch.getAttribute('aria-label'));
      order.push(key);
      if (swatch.dataset.url && !prevUrls.has(key)) prevUrls.set(key, swatch.dataset.url);
    });
    const more = nextGroup.querySelector('.color-swatch-more');
    const swatches = Array.from(nextGroup.querySelectorAll('.color-swatch-new'));
    const byLabel = new Map();
    swatches.forEach(function (swatch) {
      const key = normalizeText(swatch.getAttribute('aria-label'));
      if (!byLabel.has(key)) byLabel.set(key, []);
      byLabel.get(key).push(swatch);
    });
    const used = new Set();
    order.forEach(function (key) {
      const bucket = byLabel.get(key);
      if (!bucket || !bucket.length) return;
      const swatch = bucket.shift();
      used.add(swatch);
      nextGroup.insertBefore(swatch, more);
    });
    swatches.forEach(function (swatch) {
      if (used.has(swatch)) return;
      nextGroup.insertBefore(swatch, more);
    });
    const placed = Array.from(nextGroup.querySelectorAll('.color-swatch-new'));
    placed.forEach(function (swatch, index) {
      const key = normalizeText(swatch.getAttribute('aria-label'));
      if (!swatch.dataset.url && prevUrls.has(key)) swatch.dataset.url = prevUrls.get(key);
      if (swatch.classList.contains('is-selected') && productUrl) swatch.dataset.url = productUrl;
      swatch.classList.toggle('is-extra', index >= 6);
    });
    if (more && placed.length <= 6) more.remove();
  }

  async function swapProductCard(card, productUrl, keepOpen, selectedLabel) {
    if (card.dataset.swatchLoading === '1') return;
    card.dataset.swatchLoading = '1';
    card.classList.add('is-swatch-loading');
    try {
      const requestUrl = new URL(productUrl, window.location.origin);
      requestUrl.searchParams.set('sections', 'product-card-swap');
      const response = await fetch(requestUrl.toString());
      if (!response.ok) throw new Error('swatch fetch failed');
      const data = await response.json();
      const html = data['product-card-swap'];
      if (!html) throw new Error('empty section');
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('product-card');
      if (!next) throw new Error('no card');
      const floating = card.querySelector('wishlist-button-collection') || card.querySelector('wk-button');
      if (floating) {
        (next.querySelector('.product-card__media-wrapper') || next.querySelector('.product-card__figure') || next).appendChild(floating);
      }
      keepSwatchOrder(card, next, productUrl);
      const nextGroup = next.querySelector('.color-swatches-new');
      if (keepOpen) {
        nextGroup?.classList.add('is-expanded');
        const moreButton = nextGroup?.querySelector('.color-swatch-more');
        if (moreButton) {
          moreButton.setAttribute('aria-expanded', 'true');
          moreButton.setAttribute('aria-label', 'Fewer colors');
        }
      } else nextGroup?.classList.remove('is-expanded');
      if (selectedLabel && nextGroup && !nextGroup.querySelector('.color-swatch-new.is-selected')) {
        const match = Array.from(nextGroup.querySelectorAll('.color-swatch-new')).find(function (item) {
          return normalizeText(item.getAttribute('aria-label')) === selectedLabel;
        });
        if (match) {
          match.classList.add('is-selected');
          match.setAttribute('aria-pressed', 'true');
          match.dataset.url = productUrl;
        }
      }
      card.replaceWith(next);
      initProductCards([next], { skipFade: true });
    } catch (error) {
      card.dataset.swatchLoading = '';
      card.classList.remove('is-swatch-loading');
    }
  }

  document.addEventListener('click', async function (event) {
    const more = event.target.closest('.color-swatch-more');
    const swatch = event.target.closest('.color-swatch-new');
    if (!more && !swatch) return;
    const card = (more || swatch).closest('product-card');
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();

    if (more) {
      if (colorSwatchMobile.matches) {
        const selected = card.querySelector('.color-swatch-new.is-selected');
        const href = (selected && selected.dataset.url) || card.querySelector('a.product-title')?.getAttribute('href');
        if (href) window.location.href = href;
        return;
      }
      const group = more.closest('.color-swatches-new');
      if (!group) return;
      const expanded = group.classList.toggle('is-expanded');
      more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      more.setAttribute('aria-label', expanded ? 'Fewer colors' : 'More colors');
      return;
    }

    if (swatch.classList.contains('is-selected')) return;
    const group = swatch.closest('.color-swatches-new');
    const keepOpen = !!(group && group.classList.contains('is-expanded'));
    const productUrl = await resolveSwatchUrl(card, swatch);
    if (!productUrl) return;
    const siblings = group ? Array.from(group.querySelectorAll('.color-swatch-new')).filter(function (item) {
      return item !== swatch;
    }) : [];
    if (siblings.length === 1 && !siblings[0].dataset.url) {
      const currentHref = card.querySelector('a.product-title')?.getAttribute('href');
      if (currentHref) siblings[0].dataset.url = new URL(currentHref, window.location.origin).pathname;
    }
    swatch.dataset.url = productUrl;
    swapProductCard(card, productUrl, keepOpen, normalizeText(swatch.getAttribute('aria-label')));
  });

  /* ---------------------------------------------------------------------
     Expose & bootstrap
  --------------------------------------------------------------------- */
  window.initProductCards = initProductCards;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductCards());
  } else {
    initProductCards();                       // page already loaded
  }
})();